enum ChecklistType {
    CHECKLIST = 0,
    CUSTOM = 1,
}

export default ChecklistType;